// extracted by mini-css-extract-plugin
module.exports = {"primaryButton":"Button__primaryButton","secondaryButton":"Button__secondaryButton","advertButton":"Button__advertButton","spinner":"Button__spinner"};